import { FeatureId } from "@/server-types";

import { api } from "@/lib/api-client";

export const useClientFeature = () => {
  const { data: featuresData } = api.client.useGetClientFeatures();

  const isFeatureEnabled = (feature: FeatureId) => {
    return !!featuresData?.features?.includes(feature);
  };

  return { isFeatureEnabled };
};
